export default __webpack_public_path__ + "static/other-f8629754744048b3c27978930dbfa857.png";